export default "__VITE_ASSET__CifZAF8Q__"